export default __webpack_public_path__ + "static/media/Kitchen.90e4af92.jpeg";